export default __webpack_public_path__ + "static/LatoRegular-39ac38d8a27bed2a16e4b0ebd0914520.woff2";